<template>
  <v-container v-if="!!showDialog">
    <v-container fluid>
      <v-col md="12">
        <v-form ref="paymentForm">
          <v-row>
            <v-col md="3" class="col-xs-6">
              <v-text-field
                :name="Math.random()"
                label="Payment Amount"
                :value="paymentAmount"
                prepend-icon="mdi-calculator"
                type="text"
                required
                :disabled="true"
              ></v-text-field>
            </v-col>
            <!-- <v-col md="3" class="col-xs-6">
              <v-text-field
                :name="Math.random()"
                label="Total"
                :value="total"
                prepend-icon="mdi-calculator"
                type="text"
                required
                :disabled="true"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col sm="12" class="col-xs-12">
              <h2>Payment Proof</h2>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Reason
                      </th>
                      <th class="text-left">
                        Status
                      </th>
                      <th class="text-left">
                        Reference
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in paymentTable"
                      :key="item.name"
                    >
                      <td>{{ item.reason }}</td>
                      <td>{{ item.status }}</td>
                      <td>{{ item.referenceNumber }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col sm="12" class="col-xs-12">
              <v-data-table
                dense
                :items="selected"
                :disable-pagination="true"
                :hide-default-footer="true"
                :headers="headers"
                no-data-text="No Products Selected"
                :item-key="new Date().getMilliseconds().toString()"
                class="elevation-1"
                disabled
              >
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="my-5">
            <v-btn
              class="btn-reject mx-2"
              color="red darken-1"
              :disabled="isPending"
              @click="sendReceipt('FAILED')"
              >
              SET TO FAILED
            </v-btn>
          </v-row>
          <v-row class="my-5">
            <v-btn
              class="btn-confirm mx-2"
              :disabled="isPending"
              color="green"
              @click="sendReceipt('URGENT')"
              >
              SET TO URGENT
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../../store/helpers";

export default {
  data: () => ({
    isPending: false,
    headers: [
      {
        text: "EAN",
        align: "left",
        sortable: false,
        value: "ean"
      },
      {
        text: "Product",
        align: "left",
        sortable: false,
        value: "name"
      },
      {
        text: "Price",
        align: "left",
        sortable: false,
        value: "price"
      },
      {
        text: "Count",
        align: "left",
        sortable: false,
        value: "count"
      }
    ]
  }),
  props: {
    inspectMode: {
      required: false,
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      "userToken"
    ]),
    ...mapFields([
      "updatedAt",
      "createdAt",
      "selectedProducts",
      "paymentHistory",
      "receiptDateTime",
      "receiptToken",
      "paymentAmount",
      "total"
    ]),
    selected() {
      if (this.selectedProducts) return JSON.parse(this.selectedProducts);
      return []
    },
    paymentTable () {
      if (this.paymentHistory) return [this.paymentHistory];
      return []
    }
  },
  methods: {
    ...mapActions([
      "snackAlert",
      "updatePaymentStatus"
    ]),
    sendReceipt (status) {
      this.isPending = true;
      const data = {
        userToken: this.userToken,
        newPaymentStatus: status,
        receiptToken: this.receiptToken
      };
      this.updatePaymentStatus(data)
        .then(res => {
          this.isPending = false;
          this.snackAlert({
            message: "Receipt Updated",
            type: "success"
          });
          this.$emit("hideviewer", { autopilot: true });
        })
        .catch(err => {
          this.isPending = false;
        }).finally(() => {
          this.isPending = false;
        });
      return
    },
    // calculateTotal() {
    //   let _total = 0;

    //   this.selected.forEach(product => {
    //     _total += product.count * product.price;
    //   });
    //   console.log("Total", _total)
    //   return _total.toFixed(2);
    // },
  }
};
</script>
